import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import BasicRegistrationForm from '../components/forms/BasicRegistrationForm.jsx';

const ApplyNow = () => {
  const [isFormOpen, setIsFormOpen] = useState(true);
  const navigate = useNavigate();

  const handleCloseForm = () => {
    setIsFormOpen(false);
    navigate('/');
  };

  return (
    <div className="relative min-h-screen bg-gradient-to-br from-[#111827] via-[#0f172a] to-[#020617] flex items-center justify-center p-4">
      <div className="absolute inset-0 opacity-[0.05]">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(251,191,36,0.7) 1px, transparent 0)',
            backgroundSize: '48px 48px'
          }}
        />
      </div>

      <motion.button
        type="button"
        onClick={() => navigate('/')}
        className="fixed top-8 left-8 z-40 bg-white/95 shadow-xl rounded-full px-4 py-3 hover:shadow-2xl transition-all text-[#d97706] text-lg cursor-pointer touch-manipulation"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        aria-label="Go back"
        style={{ WebkitTapHighlightColor: 'transparent' }}
      >
        ←
      </motion.button>

      <div className="relative z-10 w-full max-w-6xl">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-10"
        >
          <h1 className="text-4xl md:text-5xl font-light tracking-tight text-white mb-4">
            Begin Your Investment Journey
          </h1>
          <p className="text-lg md:text-xl text-white/80 max-w-3xl mx-auto font-light">
            Take the first step toward partnering with Blockfirst Capital. Submit your basic details to unlock our private investment opportunities.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.15 }}
          className="grid md:grid-cols-3 gap-8 mb-12"
        >
          {[{
            title: 'Quick Application',
            description: 'Share your core information in minutes to start the onboarding process.',
            step: '1'
          }, {
            title: 'Dedicated Follow-Up',
            description: 'Our client services team will reach out with next steps and verification.',
            step: '2'
          }, {
            title: 'Access Opportunities',
            description: 'Open your account and begin allocating into curated institutional strategies.',
            step: '3'
          }].map((item) => (
            <div key={item.step} className="bg-white/95 rounded-2xl p-6 shadow-lg border border-white/30">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#f59e0b] to-[#fbbf24] text-[#111827] flex items-center justify-center font-semibold mb-4">
                {item.step}
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{item.description}</p>
            </div>
          ))}
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="bg-white/95 rounded-2xl shadow-xl border border-white/30 p-10 text-center backdrop-blur"
        >
          <h2 className="text-2xl md:text-3xl font-semibold text-gray-900 mb-3">
            Ready to Get Started?
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto mb-6">
            Complete the short form to connect with our onboarding specialists. We will guide you through the full registration tailored to your objectives.
          </p>
          <motion.button
            type="button"
            onClick={() => setIsFormOpen(true)}
            className="inline-flex items-center justify-center bg-gradient-to-r from-[#f59e0b] to-[#fbbf24] text-[#111827] px-8 py-3 rounded-full font-semibold shadow-lg hover:shadow-xl transition-shadow cursor-pointer touch-manipulation"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            style={{ WebkitTapHighlightColor: 'transparent' }}
          >
            Start Your Application
          </motion.button>
        </motion.div>
      </div>

      <BasicRegistrationForm isOpen={isFormOpen} onClose={handleCloseForm} />
    </div>
  );
};

export default ApplyNow;
